import { arrayOf, shape, string, bool } from 'prop-types';

import { TreatmentCategory } from '../treatment-category';
import styles from './TreatmentCategoryList.scss';

export const TreatmentCategoryList = ({ treatmentCategories, isNewBrandPageFeatureEnabled }) => (
  <div className={styles.List}>
    {treatmentCategories.map((treatment) => (
      <div className={styles.Column} key={treatment.id}>
        <TreatmentCategory
          {...treatment}
          isNewBrandPageFeatureEnabled={isNewBrandPageFeatureEnabled}
        />
      </div>
    ))}
  </div>
);

TreatmentCategoryList.propTypes = {
  treatmentCategories: arrayOf(
    shape({
      id: string.isRequired,
      name: string.isRequired,
      thumbnailImg: string.isRequired,
    }),
  ).isRequired,
  isNewBrandPageFeatureEnabled: bool.isRequired,
};
